export const PROJECT_TYPE = { PHOTOS: 'Images', VIDEOS: 'Videos', PHOTOS_AND_VIDEOS: 'Images and Videos', FREE_FLIGHT: 'Free Flight', AEROPATH: 'Tower Inspection' }
export const PROJECT_STATE = {
	ALLOCATE_PILOT: 'Allocate Pilot',
	ALLOTTED: 'Allotted',
	IN_FLIGHT: 'In Flight',
	COMPLETED: 'Data Delivered',
	RESOLVED: 'Resolved',
	DATA_REJECTED_FINAL: 'Final Data Rejected',
}
